import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Menu,
  MenuItem,
  Popover,
  IconButton,
  TextField,
  Chip,
} from "@mui/material";

import {
  Select,
  Checkbox,
  FormControl,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import ScrollbarStyles from "./../customScroll";

import TextButton from "../button";
import { Colors } from "../../config/default";
import {
  FONT_SIZE_LARGE,
  FONT_SIZE_MEDIUM,
  TEXT_EDITOR_KEY,
} from "../../constants/appConstants";
import styled from "styled-components";
import {
  CreateSmsDraft,
  DeleteDraft,
  GetCustomVariable,
  GetUserActiveSignature,
  SaveAsDraft,
  SendEmailSmsCase,
  UpdateDraft,
  UpdateSmsDraft,
} from "../../services/services";
import { useToast } from "../../toast/toastContext";
import { ArrowRight, Delete, ExpandMore, Close } from "@mui/icons-material";
import { handleNumberInput, isEmailValid } from "../../common";
import { Editor } from "@tinymce/tinymce-react";
import Dropdown from "../dropdown";
import ClickAwayListener from "@mui/material/ClickAwayListener";

const lineStyle = {
  width: "100%",
  height: "1px",
  backgroundColor: "#EAEBEB",
  margin: "1rem 0",
};
const StyledInput = styled.input`
  font-family: "Nunito";
  background-color: ${Colors.BG_LIGHT_GRAY};
  height: 2.5rem;
  color: ${Colors.DIM_LIGHT_GRAY};
  padding-left: 1rem;
  border: none;
  outline: none;
  border-radius: 5px;
  width: 98%;
`;

const buttonStyling = {
  textTransform: "none",
  color: Colors.BLACK,
  fontFamily: "Nunito",
  fontSize: FONT_SIZE_LARGE,
  textAlign: "left",
};
const inputContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  border: "1px solid #ccc",
  borderRadius: "5px",
  padding: "5px",
  marginBottom: "10px",
  borderRadius: "10px",
};

const emailChipStyle = {
  backgroundColor: "#EAEBEB",
  borderRadius: "3px",
  padding: "5px 10px",
  marginRight: "5px",
  display: "flex",
  alignItems: "center",
  fontFamily: "Nunito",
  fontSize: FONT_SIZE_MEDIUM,
  borderRadius: "10px",
};
const removeIconStyle = {
  marginLeft: "8px",
  cursor: "pointer",
  color: "#888",
};

const fontStyling = { fontSize: FONT_SIZE_LARGE, fontFamily: "Nunito" };

const divStyling = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: Colors.BG_LIGHT_GRAY,
  borderRadius: "5px",
  height: "2.5rem",
  cursor: "pointer",
  fontSize: FONT_SIZE_LARGE,
  fontFamily: "Nunito",
  padding: "0px 10px",
  width: "98%",
  marginBottom: "auto",
};

const smsTemplateStyling = {
  backgroundColor: Colors.BG_LIGHT_GRAY,
  border: "none",
  outline: "none",
  minWidth: "100%",
  maxWidth: "100%",
  maxHeight: "40vh",
  padding: "1em",
  fontFamily: "Nunito",
  borderRadius: "5px",
};

export default function SendEmailCase({
  buttonName,
  handleClose,
  headerName,
  caseDataId,
  GetLogsById,
  from,
  to,
  content,
  emailSubject,
  replyCheck,
  data,
  verifiedSenders,
  compose,
  getAllInboxData,
  emailOrCompose,
  updateDraft,
  draftId,
  attachment,
  threadId,
  loginUser,
  caseData,
  cc,
  ccData,
  emailType,
}) {
  const selectRef = useRef(null);
  const toPhoneClientNo = caseData?.debtor?.basicInformation?.phone;
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [sendTo, setSendTo] = useState(
    emailType === "received"
      ? from
      : emailType === "sent"
      ? to
      : from || toPhoneClientNo || ""
  );
  const [bulkEmail, setBulkEmail] = useState(data?.allEmails || []);
  const [selectedEmail, setSelectedEmail] = useState("");
  const [bulkEmailTemplates, setBulkEmailTemplates] = useState(
    data?.emailTemplates || []
  );
  const [selectedEmailTemplates, setSelectedEmailTemplates] = useState("");
  const [bulkSmsTemplates, setBulkSmsTemplates] = useState(
    data?.smsTemplates || []
  );
  const [selectedSmsTemplates, setSelectedSmsTemplates] = useState("");
  const [sendFrom, setSendFrom] = useState(
    emailType === "sent" ? from : replyCheck ? to || "" : ""
  );
  const [selectedValue, setSelectedValue] = useState(to || "");

  const [subject, setSubject] = useState(emailSubject || "");

  const [preview, setPreview] = useState(
    replyCheck ? `<p></p><p></p>${content}` : content || ""
  );

  const [fromNumber, setFromNumber] = useState(
    to ||
      parseInt(
        loginUser?.twilioNo
          ? parseInt(loginUser.twilioNo.replace("+1", ""))
          : data?.defaultNumber,
        10
      )
  );
  const [errors, setErrors] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [customVariables, setCustomVariables] = useState({});
  const [existingFiles, setExistingFiles] = useState(attachment || []);
  const [removedFiles, setRemovedFiles] = useState([]);
  const { showToast } = useToast();

  const [signature, setSignature] = useState("");

  const GetUserActiveSignatures = async () => {
    const res = await GetUserActiveSignature();
    if (res?.status === 200) {
      const userSignature = res?.data?.data?.signature || "";
      setSignature(userSignature);
      setPreview((prev) =>
        prev.includes(userSignature) ? prev : `${userSignature}`
      );
    }
  };

  useEffect(() => {
    if (!headerName && buttonName !== "draft") {
      GetUserActiveSignatures();
    }
  }, [headerName]);

  const updatePreview = (newContent) => {
    setPreview((prevContent) => {
      // Check if the preview contains the signature
      if (prevContent.includes(signature)) {
        // Separate content from the signature
        const contentWithoutSignature = prevContent
          .replace(signature, "")
          .trim();
        return `${contentWithoutSignature}\n\n${newContent}\n\n${signature}`;
      } else {
        // If signature is removed, just add new content
        const contentWithoutSignature = prevContent.trim();
        return `${contentWithoutSignature}\n\n${newContent}\n\n`;
      }
    });
  };

  const getVariableAndEvents = async () => {
    const resVariable = await GetCustomVariable();
    if (resVariable?.status === 200) {
      setCustomVariables(resVariable?.data?.data);
    }
  };

  useEffect(() => {
    getVariableAndEvents();
  }, []);

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setSubMenuAnchorEl(null);
  };

  const handleOpenSubMenu = (event, category) => {
    setSubMenuAnchorEl(event.currentTarget);
    setSelectedCategory(category);
  };

  useEffect(() => {
    const selectedTemplate = bulkEmailTemplates?.find(
      (template) => template?.name === selectedEmailTemplates
    );
    if (selectedTemplate) {
      updatePreview(selectedTemplate?.content);
    }
  }, [selectedEmailTemplates]);

  const handleMenuClick = (action, selectedCategory) => {
    setSubMenuAnchorEl(null);
    setAnchorEl(null);
    if (action) {
      const newContent = `{{${selectedCategory}.${action}}}`;
      updatePreview(newContent);
    }
  };

  useEffect(() => {
    const selectedTemplate = bulkSmsTemplates?.find((template) => {
      if (template?.name === selectedSmsTemplates) {
        setPreview((prevContent) => prevContent + template?.content);
      }
    });
  }, [selectedSmsTemplates]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSendTo(value);
    if (value?.length > 10 || value?.length < 10) {
      setErrors("Phone number must be exactly 10 digits.");
    } else {
      setErrors("");
    }
  };

  const disable =
    !sendTo?.trim() ||
    (!headerName && !replyCheck && !selectedValue) ||
    (!headerName && !subject?.trim()) ||
    !preview?.trim() ||
    (headerName && errors);

  const menu = replyCheck
    ? []
    : verifiedSenders?.map((name) => ({
        label: name,
        value: name,
      }));

  const menuSendto = [
    {
      label: "Custom Email",
      value: "Custom Email",
    },
    ...(bulkEmail?.map((name) => ({
      label: name,
      value: name,
    })) || []),
  ];

  const menuBulkTemplates = bulkEmailTemplates?.map((item) => ({
    label: item?.name,
    value: item?.name,
  }));

  const menuBulkSmsTemplates = bulkSmsTemplates?.map((item) => ({
    label: item?.name,
    value: item?.name,
  }));

  const deleteDraft = async () => {
    if (headerName) {
      const res = await DeleteDraft(draftId);
      if (res?.status === 200) {
        getAllInboxData(false, false);
      }
    } else {
      const res = await DeleteDraft(draftId);
      if (res?.status === 200) {
        getAllInboxData(false, false);
      }
    }
  };

  const handleSend = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("content", preview);
    if (!headerName) {
      if (selectedFiles?.length > 0) {
        selectedFiles.forEach((file) => {
          formData.append("files", file);
        });
      } else {
        formData.append("files", `[]`);
      }
      if (existingFiles?.length > 0) {
        formData.append("signedUrls", JSON.stringify(existingFiles));
      } else {
        formData.append("signedUrls", `[]`);
      }
      formData.append(
        "sendTo",
        compose || replyCheck
          ? sendTo
          : selectedEmail === "Custom Email"
          ? sendTo
          : selectedEmail
      );
      formData.append("from", replyCheck ? sendFrom : selectedValue);
      formData.append("subject", subject);
      const ccString = JSON.stringify([
        ...selectedValues,
        // ...manualEmails,
        ...(ccData ? ccData : []),
      ]);

      formData.append("cc", ccString);
    } else {
      formData.append("from", fromNumber.toString());
      formData.append("sendTo", sendTo.toString());
    }
    const resEmail = await SendEmailSmsCase(
      caseDataId || "1231123",
      headerName
        ? "sms"
        : compose
        ? "compose"
        : emailOrCompose === "compose"
        ? "compose"
        : "email",
      formData,
      threadId || ""
    );
    if (resEmail?.status === 200) {
      showToast(resEmail?.data?.message, "success");
      getAllInboxData && getAllInboxData(false, false);
      draftId && deleteDraft();
      setBulkEmail([]);
      setBulkEmailTemplates([]);
      setBulkSmsTemplates([]);
      setSelectedSmsTemplates("");
      setSelectedEmailTemplates("");
      setSelectedEmail("");
      setSendTo("");
      setSubject("");
      setPreview("");
      handleClose();
      GetLogsById && GetLogsById(caseDataId);
    } else {
      const errorMessage = resEmail?.response?.data?.message;
      showToast(errorMessage, "error");
    }
    setLoading(false);
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setSelectedFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const handleSaveDraft = async () => {
    setDraftLoading(true);
    const formData = new FormData();
    if (selectedFiles?.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });
    } else {
      formData.append("files", `[]`);
    }

    formData.append(
      "sendTo",
      headerName ? sendTo : compose || replyCheck ? sendTo : selectedEmail
    );
    formData.append("content", preview);
    formData.append("subject", subject);
    const ccString = JSON.stringify([
      ...selectedValues,
      // ...manualEmails,
      ...(ccData ? ccData : []),
    ]);
    formData.append("cc", ccString);
    formData.append("from", replyCheck ? sendFrom : selectedValue);
    formData.append("caseId", caseDataId || "");
    const resEmail = await SaveAsDraft(formData);
    if (resEmail?.status === 201) {
      getAllInboxData && getAllInboxData(false, false);
      handleClose();
      showToast(resEmail?.data?.message, "success");
    } else {
      const errorMessage = resEmail?.response?.data?.message;
      showToast(errorMessage, "error");
    }
    setDraftLoading(false);
  };

  const handleSaveSmsDraft = async () => {
    setDraftLoading(true);
    const payload = {
      sendTo: sendTo || "",
      from: fromNumber || "",
      content: preview || "",
      caseId: caseDataId || "",
    };
    const res = await CreateSmsDraft(payload);
    if (res?.status === 201) {
      getAllInboxData && getAllInboxData(false, false);
      handleClose();
      showToast(res?.data?.message, "success");
    } else {
      const errorMessage = res?.response?.data?.message;
      showToast(errorMessage, "error");
    }
    setDraftLoading(false);
  };

  const handleUpdateDraft = async () => {
    setDraftLoading(true);
    const formData = new FormData();
    if (selectedFiles?.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("files", file);
      });
    } else {
      formData.append("files", `[]`);
    }
    if (removedFiles?.length > 0) {
      formData.append("removedFiles", JSON.stringify(removedFiles));
    } else {
      formData.append("removedFiles", `[]`);
    }
    formData.append(
      "sendTo",
      headerName ? sendTo : compose || replyCheck ? sendTo : selectedEmail
    );
    formData.append("content", preview);
    formData.append("subject", subject);
    const ccString = JSON.stringify([
      ...selectedValues,
      ...manualEmails,
      ...(ccData ? ccData : []),
    ]);
    formData.append("cc", ccString);
    formData.append("from", replyCheck ? sendFrom : selectedValue);
    formData.append("caseId", caseDataId || "");
    const resEmail = await UpdateDraft(draftId, formData);
    if (resEmail?.status === 200) {
      getAllInboxData && getAllInboxData(false, false);
      handleClose();
      showToast(resEmail?.data?.message, "success");
    } else {
      const errorMessage = resEmail?.response?.data?.message;
      showToast(errorMessage, "error");
    }
    setDraftLoading(false);
  };

  const handleSmsUpdateDraft = async () => {
    setDraftLoading(true);
    const payload = {
      sendTo: sendTo || "",

      from: fromNumber || "",
      content: preview || "",
      caseId: caseDataId || "",
    };
    const res = await UpdateSmsDraft(draftId, payload);
    if (res?.status === 200) {
      getAllInboxData && getAllInboxData(false, false);
      handleClose();
      showToast(res?.data?.message, "success");
    } else {
      const errorMessage = res?.response?.data?.message;
      showToast(errorMessage, "error");
    }
    setDraftLoading(false);
  };

  const handleRemoveFile = (index) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleRemoveExistingFile = (index) => {
    const removedFile = existingFiles[index];
    setRemovedFiles((prevRemoved) => [...prevRemoved, removedFile]);
    setExistingFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const [selectedKey, setSelectedKey] = useState("");
  const [selectedValues, setSelectedValues] = useState([]);
  const [manualEmails, setManualEmails] = useState([]);
  const [newEmail, setNewEmail] = useState("");

  const handleKeyChange = (e) => {
    setSelectedKey(e.target.value);
  };

  const handleCheckboxChange = (email) => {
    if (selectedValues.includes(email)) {
      setSelectedValues(selectedValues.filter((item) => item !== email));
    } else {
      setSelectedValues([...selectedValues, email]);
    }
  };

  const handleAddEmail = () => {
    const trimmedEmail = newEmail.trim();
    if (
      trimmedEmail &&
      isEmailValid(trimmedEmail) &&
      !manualEmails.includes(trimmedEmail)
    ) {
      setManualEmails((prev) => [...prev, trimmedEmail]);
      setSelectedValues((prev) => [...prev, trimmedEmail]);
      setNewEmail("");
    }
  };

  // Determine if the button should be disabled
  const isButtonDisabled = !(
    newEmail &&
    isEmailValid(newEmail) &&
    !manualEmails?.includes(newEmail)
  );

  return (
    <>
      <Grid container sx={{ justifyContent: "space-between" }}>
        <Typography
          sx={{
            fontFamily: "Nunito",
            fontWeight: "600",
            color: Colors.DARK_GRAY,
            fontSize: FONT_SIZE_LARGE,
          }}
        >
          {headerName ? "SEND SMS" : "SEND EMAIL"}
        </Typography>
      </Grid>
      <Box sx={lineStyle} />
      {headerName && (
        <Grid container item sx={{ marginBottom: "0.5rem" }}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontFamily: "Nunito",
                fontWeight: "600",
                color: Colors.DARK_GRAY,
                fontSize: FONT_SIZE_LARGE,
              }}
            >
              From
            </Typography>
            <StyledInput
              type="number"
              placeholder="Exclude Country Code*"
              value={fromNumber}
              onChange={(e) => setFromNumber(e.target.value)}
              onKeyDown={handleNumberInput}
              disabled
            />
          </Grid>
        </Grid>
      )}
      <Grid
        container
        item
        style={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Grid item xs={6}>
          <Typography
            sx={{
              fontFamily: "Nunito",
              fontWeight: "600",
              color: Colors.DARK_GRAY,
              fontSize: FONT_SIZE_LARGE,
            }}
          >
            To
          </Typography>
          {headerName ? (
            <>
              <StyledInput
                type="number"
                placeholder="Exclude Country Code*"
                value={sendTo}
                onChange={(e) => handleInputChange(e)}
                onKeyDown={handleNumberInput}
                error={errors}
              />
              {errors ? (
                <Box
                  sx={{
                    color: "red",
                    fontSize: "9.3px",
                    height: "0.7rem",
                  }}
                >
                  {errors}
                </Box>
              ) : (
                <Box
                  sx={{
                    color: "red",
                    height: "0.7rem",
                  }}
                ></Box>
              )}
            </>
          ) : compose || replyCheck ? (
            <StyledInput
              type="text"
              placeholder="Send To*"
              value={sendTo}
              onChange={(e) => setSendTo(e.target.value)}
            />
          ) : (
            <>
              {selectedEmail === "Custom Email" ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <StyledInput
                    type="text"
                    placeholder="Send To*"
                    value={sendTo}
                    onChange={(e) => setSendTo(e.target.value)}
                    sx={{ flex: 1, height: "2.5rem" }}
                  />
                  <IconButton
                    onClick={() => {
                      setSelectedEmail("");
                      setSendTo("");
                    }}
                  >
                    <Close sx={{ fontSize: "1rem" }} />
                  </IconButton>
                </div>
              ) : (
                <Dropdown
                  height="2.5rem"
                  menuItems={menuSendto}
                  menuWidth="11.7rem"
                  placeholder="Send to"
                  backgroundColor={Colors.BG_LIGHT_GRAY}
                  hoverColor={Colors.BG_LIGHT_GRAY}
                  width="98%"
                  selectedValue={selectedEmail}
                  setSelectedValue={(val) => {
                    setSelectedEmail(val);
                    if (val !== "Custom Email") {
                      setSendTo(val);
                    } else {
                      setSendTo("");
                    }
                  }}
                  emptyMessage=" Email Not Found"
                />
              )}
            </>
          )}
        </Grid>
        {headerName ? null : (
          <Grid xs={6}>
            <>
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: "600",
                  color: Colors.DARK_GRAY,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                From
              </Typography>
              {!replyCheck && (
                <Dropdown
                  height="2.5rem"
                  menuItems={menu}
                  menuWidth="11.7rem"
                  placeholder="Send From"
                  backgroundColor={Colors.BG_LIGHT_GRAY}
                  hoverColor={Colors.BG_LIGHT_GRAY}
                  width="98%"
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  emptyMessage="No Verfied Sender"
                />
              )}

              {replyCheck && (
                <StyledInput
                  type="text"
                  placeholder="Send From*"
                  value={sendFrom}
                  onChange={(e) => setSendFrom(e.target.value)}
                />
              )}
            </>
          </Grid>
        )}
        {headerName ? null : (
          <Grid item xs={6}>
            <>
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: "600",
                  color: Colors.DARK_GRAY,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                Subject
              </Typography>
              <StyledInput
                type="text"
                placeholder="Add Subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </>
          </Grid>
        )}
        {!compose && (
          <>
            <Grid item xs={6}>
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: "600",
                  color: Colors.DARK_GRAY,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                Variable
              </Typography>
              <div>
                <div
                  style={divStyling}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                  <span>Select Variable</span>
                  <span style={{ marginTop: "5px" }}>
                    <ExpandMore />
                  </span>
                </div>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseMenu}
                >
                  {Object.keys(customVariables)
                    ?.filter((category) => category !== "event") // Exclude the 'event' key
                    .map((category) => (
                      <MenuItem
                        key={category}
                        onClick={(event) => handleOpenSubMenu(event, category)}
                        sx={{
                          ...fontStyling,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {category?.charAt(0).toUpperCase() + category?.slice(1)}
                        <ArrowRight />
                      </MenuItem>
                    ))}
                </Menu>
                <Popover
                  anchorEl={subMenuAnchorEl}
                  open={Boolean(subMenuAnchorEl)}
                  onClose={() => setSubMenuAnchorEl(null)}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <Grid
                    sx={{
                      maxHeight: "300px",
                      overflowY: "auto",
                      ...ScrollbarStyles,
                    }}
                  >
                    {selectedCategory &&
                      Object.entries(customVariables[selectedCategory])?.map(
                        ([label, action]) => (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Button
                              sx={buttonStyling}
                              onClick={() =>
                                handleMenuClick(label, selectedCategory)
                              }
                            >
                              {action}
                            </Button>
                          </div>
                        )
                      )}
                  </Grid>
                </Popover>
              </div>
              <Box
                sx={{
                  height: "0.7rem",
                }}
              ></Box>
            </Grid>
          </>
        )}

        {headerName ? null : (
          <Grid item xs={6}>
            <>
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: "600",
                  color: Colors.DARK_GRAY,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                Attachment
              </Typography>
              <input
                type="file"
                multiple
                onChange={(e) => handleFileChange(e)}
                style={{
                  fontFamily: "Nunito",
                  backgroundColor: Colors.BG_LIGHT_GRAY,
                  height: "2.5rem",
                  color: Colors.DIM_LIGHT_GRAY,
                  paddingLeft: "1rem",
                  border: "none",
                  outline: "none",
                  borderRadius: "5px",
                  width: "98%",
                }}
              />
            </>
          </Grid>
        )}
        <Grid item xs={compose ? 12 : 6}>
          <>
            <Typography
              sx={{
                fontFamily: "Nunito",
                fontWeight: "600",
                color: Colors.DARK_GRAY,
                fontSize: FONT_SIZE_LARGE,
              }}
            >
              {headerName ? "Sms Templates" : "Email Templates"}
            </Typography>
            <Dropdown
              height="2.5rem"
              menuItems={headerName ? menuBulkSmsTemplates : menuBulkTemplates}
              menuWidth="11.7rem"
              placeholder={
                headerName ? "Select SMS Templates" : "Select Email Templates"
              }
              backgroundColor={Colors.BG_LIGHT_GRAY}
              hoverColor={Colors.BG_LIGHT_GRAY}
              width="98%"
              selectedValue={
                headerName ? selectedSmsTemplates : selectedEmailTemplates
              }
              setSelectedValue={
                headerName ? setSelectedSmsTemplates : setSelectedEmailTemplates
              }
              emptyMessage={
                headerName ? "Empty Sms Templates" : "Empty Email Templates"
              }
            />
          </>
        </Grid>
        {headerName ? null : (
          <>
            <Grid item xs={compose ? 12 : 6}>
              <Typography
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: "600",
                  color: Colors.DARK_GRAY,
                  fontSize: FONT_SIZE_LARGE,
                }}
              >
                CC
              </Typography>

              <Box sx={{ position: "relative", width: "100%" }} ref={selectRef}>
                <FormControl
                  sx={{
                    fontFamily: "Nunito",
                    width: "98%",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "5px",
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "6px 10px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      minHeight: "30px",
                      alignItems: "flex-start",
                    },
                  }}
                >
                  <Select
                    value={selectedKey}
                    onChange={handleKeyChange}
                    displayEmpty
                    renderValue={() => {
                      if (!selectedValues || selectedValues?.length === 0) {
                        return (
                          <Box
                            style={{
                              color: Colors.DARK_GRAY,
                              fontFamily: "Nunito",
                              fontSize: "0.875rem",
                              textAlign: "center",
                              marginTop: ".3rem",
                            }}
                          >
                            Select CC
                          </Box>
                        );
                      }

                      return (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            maxHeight: "4rem",
                            overflowY: "auto",
                            ...ScrollbarStyles,
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {selectedValues?.map((email) => (
                            <Box
                              key={email}
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Chip
                                label={email}
                                onDelete={() => handleCheckboxChange(email)}
                                sx={{
                                  fontFamily: "Nunito",
                                  backgroundColor: Colors.VIOLET,
                                  color: Colors.DARK_GRAY,
                                }}
                              />
                            </Box>
                          ))}
                        </Box>
                      );
                    }}
                    sx={{
                      fontFamily: "Nunito",
                      color: Colors.DARK_GRAY,
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 200,
                          overflowY: "auto",
                        },
                      },
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>Select CC</em>
                    </MenuItem>
                    <MenuItem value="Custom">Custom Email</MenuItem>
                    {Object?.keys(cc)?.map((key) => (
                      <MenuItem key={key} value={key}>
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {selectedKey === "Custom" && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setSelectedKey("");
                    }}
                  >
                    <FormGroup
                      sx={{
                        marginTop: "10px",
                        padding: "10px",
                        borderRadius: "5px",
                        overflowY: "auto",
                        border: "1px solid #ddd",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          maxHeight: "15rem",
                        }}
                      >
                        <TextField
                          value={newEmail}
                          onChange={(e) => setNewEmail(e.target.value)}
                          placeholder="Enter email"
                          size="small"
                          sx={{
                            marginTop: "10px",
                            color: Colors.DARK_GRAY,
                            fontFamily: "Nunito",
                          }}
                        />
                        <Button
                          onClick={handleAddEmail}
                          sx={{
                            marginTop: "5px",
                            backgroundColor: Colors.SKY_BLUE,
                            "&:hover": {
                              background: Colors.SKY_BLUE,
                              border: "none",
                            },
                            fontFamily: "Nunito",
                          }}
                          disabled={isButtonDisabled}
                          variant="contained"
                        >
                          Add Email
                        </Button>
                      </Box>
                    </FormGroup>
                  </ClickAwayListener>
                )}

                {selectedKey && selectedKey !== "Custom" && (
                  <ClickAwayListener
                    onClickAway={() => {
                      setSelectedKey("");
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        width: "98%",
                        backgroundColor: "#fff",
                        zIndex: 1000,
                        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        marginTop: "4px",
                      }}
                    >
                      <FormGroup
                        sx={{
                          padding: "10px",
                          maxHeight: "200px",
                          overflowY: "auto",
                          ...ScrollbarStyles,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <Typography
                            sx={{ fontFamily: "Nunito", fontWeight: 600 }}
                          >
                            Emails
                          </Typography>

                          <Box>
                            <button
                              style={{
                                fontFamily: "Nunito",
                                backgroundColor: Colors.VIOLET,
                                color: Colors.SKY_BLUE,
                                fontWeight: 600,
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                padding: "4px 10px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const emails = cc[selectedKey];
                                const areAllSelected = emails?.every((email) =>
                                  selectedValues?.includes(email)
                                );

                                if (areAllSelected) {
                                  const filtered = selectedValues?.filter(
                                    (email) => !emails?.includes(email)
                                  );
                                  setSelectedValues(filtered);
                                } else {
                                  const merged = [
                                    ...new Set([...selectedValues, ...emails]),
                                  ];
                                  setSelectedValues(merged);
                                }
                              }}
                            >
                              {cc[selectedKey]?.every((email) =>
                                selectedValues?.includes(email)
                              )
                                ? "UNSELECT All"
                                : "SELECT ALL"}
                            </button>
                          </Box>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: "120px",
                            overflowY: "auto",
                            ...ScrollbarStyles,
                          }}
                        >
                          {cc[selectedKey]?.length > 0 ? (
                            cc[selectedKey]?.map((email) => (
                              <FormControlLabel
                                key={email}
                                control={
                                  <Checkbox
                                    checked={selectedValues?.includes(email)}
                                    onChange={() => handleCheckboxChange(email)}
                                    sx={{
                                      color: Colors.SKY_BLUE,
                                      "&.Mui-checked": {
                                        color: Colors.SKY_BLUE,
                                      },
                                    }}
                                  />
                                }
                                label={email}
                                sx={{ fontFamily: "Nunito" }}
                              />
                            ))
                          ) : (
                            <Typography color="textSecondary">
                              No email exists
                            </Typography>
                          )}
                        </Box>
                      </FormGroup>
                    </Box>
                  </ClickAwayListener>
                )}
              </Box>
            </Grid>
          </>
        )}
        {!headerName && (
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "1%",
              flexWrap: "wrap",
            }}
          >
            {existingFiles?.map((item, index) => (
              <Typography
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  fontSize: FONT_SIZE_MEDIUM,
                  fontFamily: "Nunito",
                  borderRadius: "10px",
                  border: `1px solid ${Colors.SKY_BLUE}`,
                  width: "24%",
                  mt: "10px",
                }}
              >
                {item?.originalFileName}
                <IconButton onClick={() => handleRemoveExistingFile(index)}>
                  <Delete
                    sx={{ color: Colors.ORANGE_COLOR, fontSize: "16px" }}
                  />
                </IconButton>
              </Typography>
            ))}
            {selectedFiles?.map((item, index) => (
              <Typography
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  fontSize: FONT_SIZE_MEDIUM,
                  fontFamily: "Nunito",
                  borderRadius: "10px",
                  border: `1px solid ${Colors.SKY_BLUE}`,
                  width: "24%",
                  mt: "10px",
                }}
              >
                {item?.name || item?.originalFileName}
                <IconButton onClick={() => handleRemoveFile(index)}>
                  <Delete
                    sx={{ color: Colors.ORANGE_COLOR, fontSize: "16px" }}
                  />
                </IconButton>
              </Typography>
            ))}
          </div>
        )}
      </Grid>
      <Grid
        container
        item
        xs={12}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <div style={{ marginTop: "1rem" }}>
          {headerName ? (
            <textarea
              placeholder="Type something"
              rows="6"
              style={smsTemplateStyling}
              value={preview}
              onChange={(e) => setPreview(e.target.value)}
            />
          ) : (
            <Editor
              style={{ margin: "0px !important" }}
              apiKey={TEXT_EDITOR_KEY}
              init={{
                menubar: false,
                toolbar:
                  "formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent | removeformat",
                height: 250,
              }}
              value={preview}
              onEditorChange={(content) => setPreview(content)}
            />
          )}
        </div>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "1rem",
          }}
        >
          <TextButton
            buttonText={updateDraft ? "Update Draft" : "Save as Draft"}
            height="2rem"
            marginRight="1rem"
            width="10rem"
            backgroundColor={Colors.SKY_BLUE}
            hoverColor={Colors.SKY_BLUE}
            onClick={
              updateDraft
                ? headerName
                  ? handleSmsUpdateDraft
                  : handleUpdateDraft
                : headerName
                ? handleSaveSmsDraft
                : handleSaveDraft
            }
            loading={draftLoading}
            disabled={
              headerName
                ? !preview?.trim() && !sendTo?.trim()
                : !selectedValue &&
                  !subject?.trim() &&
                  !preview?.trim() &&
                  !selectedEmail &&
                  !cc?.length > 0 &&
                  !selectedFiles?.length > 0
            }
          />
          <TextButton
            buttonText="CANCEL"
            height="2rem"
            marginRight="1rem"
            width="6rem"
            onClick={handleClose}
            backgroundColor={Colors.ORANGE_COLOR}
            hoverColor={Colors.ORANGE_COLOR}
          />
          <TextButton
            buttonText="SEND"
            height="2rem"
            width="6rem"
            backgroundColor={Colors.SKY_BLUE}
            hoverColor={Colors.SKY_BLUE}
            onClick={handleSend}
            disabled={disable}
            loading={loading}
          />
        </Box>
      </Grid>
    </>
  );
}
